import { ReciboReportTab } from '@/utils/reciboListUtils';

interface ReciboTypeTabsProps {
  activeTab: ReciboReportTab;
  onChange: (tab: ReciboReportTab) => void;
}

const tabs: Array<{ id: ReciboReportTab; label: string }> = [
  { id: 'inquilinos', label: 'Inquilinos' },
  { id: 'propietarios', label: 'Propietarios' },
];

export default function ReciboTypeTabs({ activeTab, onChange }: ReciboTypeTabsProps) {
  return (
    <div className="mb-4 border-b border-slate-200" role="tablist" aria-label="Tipo de recibos">
      <div className="flex gap-6">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              id={`receipt-tab-${tab.id}`}
              aria-controls="receipt-report-panel"
              aria-selected={isActive}
              onClick={() => onChange(tab.id)}
              className={`border-b-2 px-1 pb-3 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
